import React, { useState } from 'react'
import { connect } from "react-redux"
import { CreateRestaurantMenuOffer, SetRestaurantMenuOffer, DeleteRestaurantMenuOffer } from '../../redux/actions'
import { getUserLocation } from '../../utils/common'
import { Row, Col, Button } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import { LocalOffersModal } from '../'

const LocalOffers = (props) => {
  const {t} = props
  const { SearchBar, ClearSearchButton } = Search
  const { ExportCSVButton } = CSVExport

  const [ modalData, setModalData ] = useState({
    show:false
  })

  const handleOnEditModal = (params) => {
    var objects = props.restaurantMenuOffer.filter((object) => { return object.localOfferId === params })
    setModalData({
      show:true,
      locationId:objects[0].locationId,
      localOfferId:objects[0].localOfferId,
      name:objects[0].name,
      sku:objects[0].sku,
      price:objects[0].price,
      size:objects[0].size,
      description:objects[0].description,
      dateFrom:objects[0].dateFrom,
      dateTo:objects[0].dateTo,
      hasImage:objects[0].hasImage
    })
  }

  
  const handleOnCreateLocalOffer = () => {
    const userLocation = getUserLocation()
    if(userLocation)
      setModalData({
        show:true,
        mode:"create",
        locationId:userLocation,
        localOfferId:null,
        name:null,
        sku:null,
        price:null,
        size:null,
        description:null,
        dateFrom:null,
        dateTo:null,
        hasImage: false
      })
  }

  const handleOnCancelModal = () => {
    setModalData({
      show:false
    })
  }

  const handleOnChangeInputModal = (e) => {
    const { id, value } = e.target
    setModalData(prevData => ({
        ...prevData,
        [id]: value
    }))
  }

  const handleOnDeleteObject = () => {
    var obj = modalData
    props.DeleteRestaurantMenuOffer(obj)
    setModalData({
      show:false
    })
  }

  const handleOnSaveModal = () => {
    var obj = modalData
    delete (obj.show)
    if(obj.mode !== 'create')
      props.SetRestaurantMenuOffer(obj)
    else
      props.CreateRestaurantMenuOffer(obj)
    setModalData({
      show:false
    })
  }

  function dateFormatter(cell, row) {
    return (
      <span>{moment(cell).format('DD.MM.YYYY')}</span>
    )
  }

  const selectRow = {
    mode: 'checkbox',
    hideSelectColumn: true,
    clickToSelect: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      handleOnEditModal(row.localOfferId)
    }
  }

  const columns = [
    {
      dataField: 'sku',
      text: t('foodMenus-table-sku')
    },
    {
      dataField: 'name',
      text: t('foodMenus-table-name'),
      sort: true
    },
    {
      dataField: 'price',
      text: t('foodMenus-table-price'),
      sort: true
    },
    {
      dataField: 'dateFrom',
      text: t('foodMenus-table-dateFrom'),
      sort: true,
      formatter: dateFormatter
    },
    {
      dataField: 'dateTo',
      text: t('foodMenus-table-dateTo'),
      sort: true,
      formatter: dateFormatter
    }
  ]

  const defaultSorted = [{
    dataField: 'dateFrom',
    order: 'desc'
  }]

  return(
    <div className={'m-4'}>
      <Row noGutters>
        <Col className={'text-right'}>
          <Button onClick={handleOnCreateLocalOffer} variant="outline-primary">{t('button-new')}</Button>
        </Col>
      </Row>
      <ToolkitProvider
        keyField="localOfferId"
        data={ props.restaurantMenuOffer }
        defaultSorted={ defaultSorted }
        columns={ columns }
        search
      >
        {
          props => (
            <div>
              <h3>{t('foodMenus-table-sarch')}</h3>
              <SearchBar { ...props.searchProps } />
              <ClearSearchButton { ...props.searchProps } />
              <hr />
              <BootstrapTable 
                selectRow={ selectRow }
                striped
                hover
                { ...props.baseProps }
                pagination={ paginationFactory() }
              />
              <ExportCSVButton { ...props.csvProps }>{t('button-export-csv')}</ExportCSVButton>
            </div>
          )
        }
      </ToolkitProvider>
      <LocalOffersModal 
        show={modalData.show}
        data={modalData}
        handleOnCancelModal={handleOnCancelModal}
        handleOnChangeInput={handleOnChangeInputModal}
        handleOnSaveModal={handleOnSaveModal}
        handleOnRemoveModal={handleOnDeleteObject}
      />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    restaurantMenuOffer: state.restaurantMenuOffer
  }
}

export default connect(mapStateToProps,{ CreateRestaurantMenuOffer, SetRestaurantMenuOffer, DeleteRestaurantMenuOffer })(withTranslation()(LocalOffers))